<!-- 表示するべきBookGroupの一覧表示 -->
<template>
  <div class="myticket-index">
    <div v-for="r in Reservations" :key="r.id" class="index">
      <ItemIndexDemandReservation :reservation="r" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheDemandReservationsIndex",

  computed: {
    ...mapGetters("demand", ["Reservations"]),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.myticket-index {
  background: #f9f9f9;
  padding: 2vw 0;
}

.index {
  position: relative;
  clear: both;
  width: 96%;
  margin: auto;
}
.masterbook_division {
  border-bottom: 3px solid #f9f9f9;
  background: white;
  border: 1px solid #e0e0e0;
  margin-bottom: 2vw;
  border-radius: 5px;
}
</style>
